// @flow
var smoothScroll = require('smoothscroll');

const animationHelper = {

  // Animate scroll to
  //  @param element  pass if you want document to scroll to that element         [string]
  //  @param to       pass if you want to document scroll to number of Y position [number]
  //  @param duration speed / duration of animation in milliseconds               [number]
  scrollTo: (element: string = '', to: number = 0, duration: number = 500) => {
    if( element !== '' ) {
      smoothScroll(element, duration);
    } else {
      smoothScroll(to, duration);
    }
  }
}

export default animationHelper;



// WEBPACK FOOTER //
// ./src/helpers/animation.helper.js